import React from "react";
import CTAActionSelector from "./CTAActionSelector";
import CTAStatus from "./CTAStatus";

function CTAForm({
  ctaName,
  setCtaName,

  buttonLabel,
  setButtonLabel,

  actionType,
  setActionType,

  destination,
  setDestination,

  isActive,
  setIsActive,

  onSave,
  onCancel,

  error,
  saved,
}) {

  return (
    <div className="card cta-card">

      <div className="card-header bg-white">

        <h5 className="mb-1">
          Create CTA
        </h5>

        <small className="text-muted">
          Configure the CTA that visitors will see
          in the chat widget.
        </small>

      </div>


      <div className="card-body">

        {/* Error */}

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}


        {/* Success */}

        {saved && (
          <div className="alert alert-success">
            CTA saved successfully!
          </div>
        )}


        <form onSubmit={onSave}>

          {/* CTA Name */}

          <div className="mb-4">

            <label className="form-label fw-semibold">
              CTA Name
            </label>

            <input
              type="text"
              className="form-control"
              value={ctaName}
              onChange={(event) =>
                setCtaName(event.target.value)
              }
              placeholder="Example: Book a Demo CTA"
            />

            <div className="form-text">
              Internal name used to identify this CTA.
            </div>

          </div>


          {/* Button Label */}

          <div className="mb-4">

            <label className="form-label fw-semibold">
              Button Label
            </label>

            <input
              type="text"
              className="form-control"
              value={buttonLabel}
              maxLength={40}
              onChange={(event) =>
                setButtonLabel(event.target.value)
              }
              placeholder="Example: Book a Demo"
            />

            <div className="form-text">
              This text will be displayed to visitors.
            </div>

          </div>


          {/* Action */}

          <CTAActionSelector
            actionType={actionType}
            setActionType={setActionType}
            setDestination={setDestination}
          />


          {/* Destination */}

          <div className="mb-4">

            <label className="form-label fw-semibold">
              Destination
            </label>

            <input
              type="text"
              className="form-control"
              value={destination}
              onChange={(event) =>
                setDestination(event.target.value)
              }
              placeholder="Enter URL or page path"
            />

            <div className="form-text">
              Enter the destination associated with
              this CTA action.
            </div>

          </div>


          {/* Status */}

          <CTAStatus
            isActive={isActive}
            setIsActive={setIsActive}
          />


          {/* Buttons */}

          <div className="d-flex justify-content-end gap-2">

            <button
              type="button"
              className="btn btn-light border"
              onClick={onCancel}
            >
              Cancel
            </button>


            <button
              type="submit"
              className="btn btn-primary px-4"
            >
              Save CTA
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default CTAForm;